import { useScrollReveal } from "@/hooks/useScrollReveal";
import { EnfinityPrimaryBtn } from "@/components/design-system/enfinity/EnfinityButton";
import { ArrowRight } from "lucide-react";

const CALENDAR_EARLYPAY_IMAGE =
  "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/calendar-2026.png";

const EARLYPAY_BG_IMAGE =
  "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/earlypay-bg.png";

export default function SectionUnderServices() {
  const { ref } = useScrollReveal();

  return (
    <section
      ref={ref}
      className="relative py-20 lg:py-24 px-0 md:px-12 lg:px-6 xl:px-8 overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{ backgroundImage: `url('${EARLYPAY_BG_IMAGE}')` }}
      />
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="flex flex-col lg:flex-row lg:items-center gap-10 lg:gap-16">
          {/* Left: content - EnfiniPay early pay banner style */}
          <div className="flex-1 flex flex-col justify-center px-10 md:px-0">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/enfinipay-logo-presents.svg"
              alt="EnfiniPay Presents"
              className="h-6 w-auto object-contain mb-4 self-start"
            />
            
            <h2 className="text-2xl xxs:text-[55px] lg:text-[60px] xl:text-[80px] 4xl:text-[90px] font-normal text-white mb-6 !leading-tight enfinity-header-font w-[700px] xxs:w-full lg:w-[500px] xl:w-[700px] 4xl:w-[700px] max-w-full">
              Enjoy just{" "}
              <span className="text-[#00D115] enfinity-header-font">0.75% early pay</span>{" "}
              fee for your first month
            </h2>
            <p className="text-white text-base xxs:text-[1rem] lg:text-lg max-w-xl mb-8 enfinity-subtext-font">
              Need faster access to your earnings? Activate Early Pay and unlock your funds ahead of schedule with a special introductory rate of only 0.75% for{" "}
              <span className="xs:block sm:inline">Month 1.</span>
            </p>
            <a
              href="https://core.enfinity.com/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="w-fit"
            >
              <EnfinityPrimaryBtn
                className="flex items-center gap-2 w-52 !bg-white !text-[#00d115] hover:!bg-white hover:!text-[#00d115] shadow-md [&_svg]:!text-[#00d115] hover:[&_svg]:!text-[#00d115]"
              >
                <span className="enfinity-subtext-font">Apply now</span>
                <ArrowRight className="w-5 h-5 shrink-0" />
              </EnfinityPrimaryBtn>
            </a>
          </div>

          {/* Right: calendar-earlypay image */}
          <div className="flex-1 flex items-center justify-center lg:justify-end mt-4 lg:mt-0">
            <img
              src={CALENDAR_EARLYPAY_IMAGE}
              alt="Early pay calendar and payout card"
              className="w-full max-w-xl lg:max-w-3xl xl:max-w-4xl h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
